import { useAtomValue } from 'jotai';

import { gracefullyParseJson } from '../../utils';
import { selectedVisitorNotesAtom } from '../state';
import { useGetCurrentNoteSchema } from '../useGetCurrentNoteSchema';
import { ClientInformationProgressNotesDrawer } from './ClientInformationProgressNotesDrawer';
import { NoteResponseType } from './types';
import { formatNotes } from './utils';

export function ClientInformationProgressNotesDrawerWrapper() {
  const selectedVisitorNotes = useAtomValue(selectedVisitorNotesAtom);
  const {
    data: noteSchemaData,
    loading,
    error,
  } = useGetCurrentNoteSchema(selectedVisitorNotes.patientId, selectedVisitorNotes.noteType);

  const parsedNotes = gracefullyParseJson(selectedVisitorNotes.notes) as NoteResponseType;

  const formattedNotes = formatNotes(parsedNotes, noteSchemaData);

  return (
    <ClientInformationProgressNotesDrawer isLoading={loading} isError={!!error} selectedVisitorNotes={formattedNotes} />
  );
}
